/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect } from 'react';
import { Form, Overlay, Tooltip, Button } from 'react-bootstrap';
import { getIn } from 'formik';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function FormGroupWrapper(props) {
  const {
    id,
    note,
    name,
    className,
    type,
    // eslint-disable-next-line no-unused-vars
    form: { touched, errors, values, validateField },
    children,
    autofocus,
    material,
    append,
    inputRef,
    readOnly,
    plaintext,
    error,
    handleBlur,
    handleFocus,
    hideError,
    disabled,
    required,
    multiple,
    ...attrs
  } = props;
  const [focused, setFocused] = useState(false);
  const [show, setShow] = useState(false);

  const hasError =
    (!hideError && getIn(touched, name) && getIn(errors, name)) ||
    (!hideError && getIn(touched, name) && error);

  const inputEl = useRef(null);
  const errorRef = useRef(null);
  const classes = classNames(
    className,
    type,
    children.props.size && children.props.size,
    disabled && 'disabled',
    readOnly && 'readonly',
    plaintext && 'plaintext',
    autofocus && 'autofocus',
    material && 'material',
    required && 'required',
    multiple && type === 'select' && 'select-multiple',
    (focused || hasError) && 'focused',
    hasError && 'err'
  );

  useEffect(() => {
    if (hasError) setShow(true);
  }, [hasError]);

  useEffect(() => {
    let showTimer;
    if (show) showTimer = setTimeout(() => setShow(false), 3000);
    return () => clearTimeout(showTimer);
  }, [show]);

  return (
    <Form.Group controlId={id} className={classes} {...attrs}>
      {React.cloneElement(children, {
        inputRef: inputRef || inputEl,
        focused,
        hasError,
        error: getIn(errors, name) || error,
        append:
          append || hasError ? (
            <>
              {append || null}
              {!readOnly && hasError && (
                <>
                  <Button
                    ref={errorRef}
                    onClick={() => setShow(!show)}
                    variant="danger"
                    className="btn-err btn-circle-tiny position-absolute p-1"
                    style={{
                      right: '1rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 1000,
                    }}
                  >
                    <i className="fas fa-exclamation" />
                  </Button>
                  <Overlay target={errorRef.current} show={show} placement="top">
                    <Tooltip className="err-msg mb-1">{getIn(errors, name) || error}</Tooltip>
                  </Overlay>
                </>
              )}
            </>
          ) : null,
        handleBlur: (e) => {
          setFocused(false);
          if (children.props.validate) validateField(e.target.name);
          if (handleBlur) handleBlur(e);
        },
        handleFocus: (e) => {
          setFocused(true);
          if (handleFocus) handleFocus(e);
        },
      })}
      {note && <div className="text-info mt-1 mb-3 text-sm">{note}</div>}
    </Form.Group>
  );
}

FormGroupWrapper.propTypes = {
  /**
   * The name of the field (used to identify errors)
   */
  name: PropTypes.string.isRequired,
  /**
   * The form object passed down from FormIk
   */
  form: PropTypes.object.isRequired,
};

export default FormGroupWrapper;
